import Vue from 'vue';
import translator from '../localization/translator.js';

export const showNoNameInsteadOfEmptyString = str => {
  if (!str) return translator.translate('noName');
  return str;
};

Vue.filter('noname', showNoNameInsteadOfEmptyString);
